<template>
  <el-dialog
    title="Relatórios de Contratos"
    @open="reset"
    :visible.sync="visibility"
    :before-close="fechar"
    append-to-body
    v-loading="isLoading"
    :close-on-click-modal="false"
    width="45%"
  >
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk :show-message="false">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Relatório" style="font-weight: bold; margin-top: -30px;">
            <el-select
              auto-complete="off"
              v-model="relatorio.nome"
              @change="limparFiltros"
              clearable
              placeholder
              style="width: 100%;"
            >
              <el-option
                v-for="item in tiposRelatorios"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <span v-if="exibirCamposVistoria" style="color: black;">Período
      </span>
      <el-row :gutter="24" v-if="exibirCamposVistoria">
        <el-col :span="12">
          <el-form-item prop="dataInicial">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="dataFinal">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" v-if="exibirCamposVistoria">
          <el-form-item label="Tipo de Vistoria">
            <el-select
              v-model="relatorio.tipoVistoria"
              value-key="id"
              placeholder=""
              reserve-keyword
              style="width: 100%;"
            >
              <el-option key="Todos" label="Todos" :value="undefined"/>
              <el-option 
                v-for="item in tiposVistoria"
                :key="item.id"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="exibirCamposVistoria">
          <el-form-item label="Status Vistoria">
            <el-select
              v-model="relatorio.statusVistoria"
              value-key="id"
              placeholder=""
              reserve-keyword
              style="width: 100%;"
            >
              <el-option key="Todos" label="Todos" :value="undefined"/>
              <el-option
                v-for="item in statusVistoria"
                :key="item.id"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" v-if="exibirCamposVistoria">
          <el-form-item label="Data de Agendamento">
            <el-date-picker
              v-model="relatorio.dataAgendamento"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="exibirCamposVistoria">
          <el-form-item label="Data de Conclusão">
            <el-date-picker
              v-model="relatorio.dataConclusao"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="10">
        <el-col :span="16" :md="12" v-if="exibirTipoImovel">
          <el-form-item label="Tipo do Imóvel" style="width: 100%;font-weight: bold;" prop="tipoImovel">
          <el-select
            v-model="relatorio.tipoImovel"
            value-key="id"
            placeholder=""
            reserve-keyword
            clearable
            style="width: 100%">
            <el-option key="Todos" label="Todos" :value="undefined"/>
            <el-option
              v-for="item in tiposImoveis"
              :key="item.id"
              :label="item.nome"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="exibirTipoImovel ? 12 : 24" v-if="exibirEdificioCondominio">
          <el-form-item label="Condomínio" style="width: 100%;font-weight: bold;">
            <el-select
              v-model="relatorio.condominio"
              :remote-method="recuperarCondominiosSelect"
              :loading="loadingCondominios"
              value-key="id"
              placeholder=""
              loading-text="Carregando Condomínios"
              no-data-text="Nenhum Condomínio encontrado"
              filterable
              clearable
              @clear="relatorio.condominio = undefined"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in condominiosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- <el-row :gutter="10" v-if="exibirSituacaoContrato">
        <el-col :span="24" :md="24">
          <el-form-item label="Situação do Contrato" style="width: 100%;">
            <el-radio-group v-model="relatorio.situacaoContrato" label="Tipo" style="font-size: small; margin-top: 5px;" class="radio-align-column">
              <el-radio label="ATIVO" v-if="permissoes && permissoes.relatorioContratosAtivos">Todos Ativos</el-radio>
              <el-radio label="ATIVO_POR_PERIODO" v-if="permissoes && permissoes.relatorioContratosAtivos">Ativos por Período</el-radio>
              <el-radio label="NOVO" v-if="permissoes && permissoes.relatorioContratosNovos">Novos por Período</el-radio>
              <el-radio label="RENOVADO_REAJUSTADO" v-if="permissoes && permissoes.relatorioContratosRenovados">Renovados/Reajustados por Período</el-radio>
              <el-radio label="VENCIDO" v-if="permissoes && permissoes.relatorioContratosVencidos">Vencidos / À Vencer por Período</el-radio>
              <el-radio label="EM_DESOCUPACAO" v-if="permissoes && permissoes.relatorioContratosAtivos">Em Desocupação</el-radio>
              <el-radio label="FINALIZADO" v-if="permissoes && permissoes.relatorioContratosFinalizados">Finalizados por Período</el-radio>
              <el-radio label="CONTRATOS_EFETIVADOS" v-if="permissoes && permissoes.relatorioContratosEfetivados">Contratos Efetivados</el-radio>
              <el-radio label="DECLARAR_IR" v-if="permissoes && permissoes.relatorioContratosDeclararIr">Contratos para Declaração de IR</el-radio>
              <el-radio label="CONTRATOS_PRORROGADOS" v-if="permissoes && permissoes.relatorioContratosProrrogados">Contratos Prorrogados por Período</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row> -->
     <el-row :gutter="10" v-if="exibirSituacaoContrato">
        <el-col :span="24" :md="24">
          <el-form-item label="Situação do Contrato" style="width: 100%;">
            <el-select
              v-model="relatorio.situacaoContrato"
              placeholder
              style="width: 100%;"
            >
              <el-option
                v-for="item in listaSituacaoContrato"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
  
      <el-row :gutter="10" v-if="exibirFiltroValorAluguel" style="margin-bottom: 5px; margin-top: 5px;" >
        <el-col :span="24">
          <span v-if="exibirFiltroValorAluguel" style="color: #545454;font-weight: bold;" >Valor do Aluguel</span>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Mínimo">
            <money auto-complete="off" v-model="relatorio.valorInicial" v-bind="money" class="el-input__inner"/>
          </el-form-item>
        </el-col>   
        <el-col :span="12">
         <el-form-item label="Máximo">
            <money placeholder="Mínimo" auto-complete="off" v-model="relatorio.valorFinal" v-bind="money" class="el-input__inner"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirParametrosData">
        <el-col :span="16" :md="24">
          <el-form-item label="Buscar por data de:" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.parametroData" label="Tipo" style="font-size: small;">
              <el-radio label="DATA_AVISO_DESOCUPACAO" style="margin-top:5px">Aviso de Desocupação</el-radio>
              <el-radio label="DATA_PREVISAO_DESOCUPACAO" style="margin-top:5px">Previsão de Desocupação</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <p style="font-weight: bold;" v-if="exibirDatas">{{ labelDatas }}</p>
      <el-row :gutter="16" style="margin-top: -15px;" v-if="exibirDatas">
        <el-col :span="12">
          <el-form-item label="Data Inicial" style="font-weight: bold;" prop="dataInicial">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Data Final" style="font-weight: bold;" prop="dataFinal">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="exibirSituacaoContrato">
        <el-col :span="24">
          <el-form-item label="Corretor" style="width: 100%;font-weight: bold;">
            <el-select
              v-model="relatorio.corretor"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              value-key="id"
              placeholder=""
              loading-text="Carregando Usuários"
              no-data-text="Nenhum Usuário encontrado"
              filterable
              clearable
              @clear="relatorio.corretor = undefined"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirSituacaoJuridica">
        <el-col :span="16" :md="24">
          <el-form-item label="Situação Jurídica" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.situacaoJuridica" label="Tipo" style="font-size: small;">
              <el-radio label="TODOS" style="margin-top:5px">Todos</el-radio>
              <el-radio label="COBRANCA_JURIDICA" style="margin-top:5px">Em Cobrança Jurídica</el-radio>
              <el-radio label="EM_PROCESSO_JUDICIAL" style="margin-top:5px">Em Processo Judicial</el-radio>
              <el-radio label="SEM_COBRANCA_JURIDICA" style="margin-top:5px">Sem Cobrança Jurídica</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirTipoAluguel">
        <el-col :span="16" :md="24">
          <el-form-item label="Tipo Aluguel" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.tipoAluguel" label="Tipo" style="font-size: small;">
              <el-radio label="TODOS" style="margin-top:5px">Todos</el-radio>
              <el-radio label="GARANTIDO" style="margin-top:5px">Garantidos</el-radio>
              <el-radio label="NAO_GARANTIDO" style="margin-top:5px">Não Garantidos</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirSituacaoContrato && isGestaoColigados">
        <el-col :span="24" >
          <el-form-item label="Tipo de Contrato" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.tipoContrato" label="Tipo" style="font-size: small;">
              <el-radio :label="undefined" style="margin-top:5px">Todos</el-radio>
              <el-radio label="COLIGADO" style="margin-top:5px">Coligados ao Grupo</el-radio>
              <el-radio label="NAO_COLIGADO" style="margin-top:5px">Não Coligados</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirTipoGarantia">
        <el-col>
          <el-form-item label="Tipo Garantia" style="width: 100%;font-weight: bold;">
            <el-select
              v-model="relatorio.tipoGarantia"
              value-key="id"
              placeholder=""
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in tipoGarantiaPesquisa"
                :key="item.data"
                :label="item.label"
                :value="item.data">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirOrdenacao">
        <el-col :span="16" :md="24">
          <el-form-item label="Ordenação" style="width: 100%;font-weight: bold;">
            <el-radio-group v-model="relatorio.ordenacao" label="Tipo" style="font-size: small;">
              <el-radio label="ID" style="margin-top:5px">ID</el-radio>
              <el-radio label="DATA_INICIO" style="margin-top:5px">Data de Início</el-radio>
              <el-radio label="DATA_FIM" style="margin-top:5px" v-if="relatorio.situacaoContrato === 'FINALIZADO'">Data Fim do Contrato</el-radio>
              <el-radio label="DATA_VENCIMENTO" style="margin-top:5px" v-if="exibirOrdenacaoDataVencimento">Data de Vencimento</el-radio>
              <el-radio label="DATA_REAJUSTE" style="margin-top:5px" v-if="exibirOrdenacaoDataReajuste">Data de Reajuste</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirCamposVistoria">
        <el-col :span="24">
          <el-form-item label="Vistoriador" style="width: 100%;font-weight: bold;">
            <el-select
              v-model="relatorio.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              value-key="id"
              placeholder=""
              loading-text="Carregando Usuários"
              no-data-text="Nenhum Usuário encontrado"
              filterable
              clearable
              @clear="relatorio.usuario = undefined"
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirFiltroFiador" style="margin-top: 5px">
        <el-col :span="24">
          <el-checkbox
          style="color: #1D1E1F"
          label="Exibir Informações de Fiador"
          v-model="relatorio.incluirFiador">
          </el-checkbox>
        </el-col>
      </el-row>

    </el-form>
    <span slot="footer">
      <el-row style="width: 100%;">
        <el-col :span="12" style="text-align: left">
          <span> </span>
          <el-radio v-model="relatorio.xls" :label="false">PDF</el-radio>
          <el-radio v-model="relatorio.xls" :label="true">Excel</el-radio>
        </el-col>
        <el-col :span="12" style="align: right">
          <el-button type="primary" size="small" @click="gerar()" round class="btn-box-shadow">Gerar Relatório</el-button>
        </el-col>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { TIPOS_IMOVEIS, TIPO_VISTORIA, STATUS_VISTORIA, TIPO_GARANTIA_PESQUISA} from "../../../util/constantes.js";
import funcoes from '../../../util/funcoes.js';
import {Money} from 'v-money';

export default {
  props: {
    visibility: Boolean
  },
  components:{
    Money
  },
  data() {
    return {
      relatorio: {
        nome: "",
        valorInicial: undefined,
        valorFinal: undefined,
        tipoImovel: undefined,
        situacaoContrato: 'ATIVO',
        situacaoJuridica: 'TODOS',
        imovel: { operacao: 'ALUGUEL' },
        tipoAluguel: 'TODOS',
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        parametroData: 'DATA_AVISO_DESOCUPACAO',
        ordenacao: 'ID',
        xls: false,
        incluirFiador: false
      },

      filtroValorAluguel: false,

      corretor: "",
      dataInicial: funcoes.primeiroDiaMes(),
      dataFinal: funcoes.ultimoDiaMes(),
      usuario: {},

      condominiosDisponiveis: [],

      loadingUsuarios: false,
      loadingCondominios: false,

      tiposRelatorios: [],

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),

    ...mapState("loginStore", {
      isGestaoColigados(state){return state.usuarioLogado.imobiliaria.parametros.gestaoContratosColigados},
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "RELATORIOS_CONTRATOS_ALUGUEL" })[0] },
      permissoesImoveis(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "RELATORIOS_IMOVEIS_ALUGUEL" })[0] }    }),
    ...mapState('alugueisRelatoriosStore', {
      usuariosDisponiveis(state) { return state.usuariosDisponiveis }
    }),


    // VISIBILIDADE CAMPOS
    exibirFiltroFiador(){
      return this.relatorio.situacaoContrato === 'ATIVO' && this.relatorio.nome === 'CONTRATO_ALUGUEL';
    },
    exibirOrdenacaoDataVencimento(){
      return this.situacaoContrato === 'NOVO' || this.situacaoContrato === 'CONTRATOS_PRORROGADOS'
    },
    //this.relatorio.situacaoContrato != 'RENOVADO_REAJUSTADO' && this.relatorio.situacaoContrato != 'VENCIDO' && 
    //this.relatorio.situacaoContrato != 'ATIVO' && this.relatorio.situacaoContrato != 'ATIVO_POR_PERIODO';
    exibirOrdenacaoDataReajuste(){
      return this.relatorio.situacaoContrato === 'VENCIDO';
    },
    exibirFiltroValorAluguel(){
      return this.relatorio.situacaoContrato === 'ATIVO' && this.relatorio.nome === 'CONTRATO_ALUGUEL';
    },
    exibirTipoImovel() {
      return (this.relatorio.situacaoContrato === 'ATIVO' ||
        this.relatorio.situacaoContrato === 'ATIVO_POR_PERIODO' ||
        this.relatorio.situacaoContrato === 'NOVO' ||
        this.relatorio.situacaoContrato === 'RENOVADO_REAJUSTADO' ||
        this.relatorio.situacaoContrato === 'FINALIZADO' ||
        this.relatorio.situacaoContrato === 'CONTRATOS_EFETIVADOS' ||
        this.relatorio.situacaoContrato === 'EM_DESOCUPACAO' ||
        this.relatorio.situacaoContrato === 'CONTRATOS_PRORROGADOS') && (this.relatorio.nome === 'CONTRATO_ALUGUEL')
    },
    exibirEdificioCondominio() {
      return (this.relatorio.situacaoContrato === 'ATIVO' ||
        this.relatorio.situacaoContrato === 'ATIVO_POR_PERIODO' ||
        this.relatorio.situacaoContrato === 'NOVO' ||
        this.relatorio.situacaoContrato === 'RENOVADO_REAJUSTADO' ||
        this.relatorio.situacaoContrato === 'VENCIDO' ||
        this.relatorio.situacaoContrato === 'FINALIZADO' ||
        this.relatorio.situacaoContrato === 'CONTRATOS_EFETIVADOS' ||
        this.relatorio.situacaoContrato === 'EM_DESOCUPACAO' ||
        this.relatorio.situacaoContrato === 'CONTRATOS_PRORROGADOS') && (this.relatorio.nome === 'CONTRATO_ALUGUEL')
    },
    exibirParametrosData() {
      return (this.relatorio.situacaoContrato === 'EM_DESOCUPACAO') && (this.relatorio.nome === 'CONTRATO_ALUGUEL')
    },
    exibirDatas() {
      return (this.relatorio.situacaoContrato === 'ATIVO_POR_PERIODO' ||
        this.relatorio.situacaoContrato === 'NOVO' ||
        this.relatorio.situacaoContrato === 'RENOVADO_REAJUSTADO' ||
        this.relatorio.situacaoContrato === 'VENCIDO' ||
        this.relatorio.situacaoContrato === 'EM_DESOCUPACAO' ||
        this.relatorio.situacaoContrato === 'FINALIZADO' ||
        this.relatorio.situacaoContrato === 'CONTRATOS_EFETIVADOS' ||
        this.relatorio.situacaoContrato === 'CONTRATOS_PRORROGADOS') && (this.relatorio.nome === 'CONTRATO_ALUGUEL')
    },
    exibirSituacaoJuridica() {
      return (this.relatorio.situacaoContrato === 'ATIVO' ||
        this.relatorio.situacaoContrato === 'ATIVO_POR_PERIODO' ||
        this.relatorio.situacaoContrato === 'NOVO' ||
        this.relatorio.situacaoContrato === 'FINALIZADO') && (this.relatorio.nome === 'CONTRATO_ALUGUEL')
    },
    exibirTipoAluguel() {
      return (this.relatorio.situacaoContrato === 'ATIVO' ||
        this.relatorio.situacaoContrato === 'ATIVO_POR_PERIODO' ||
        this.relatorio.situacaoContrato === 'NOVO' ||
        this.relatorio.situacaoContrato === 'RENOVADO_REAJUSTADO' ||
        this.relatorio.situacaoContrato === 'FINALIZADO' ||
        this.relatorio.situacaoContrato === 'CONTRATOS_EFETIVADOS' ||
        this.relatorio.situacaoContrato === 'CONTRATOS_PRORROGADOS') && (this.relatorio.nome === 'CONTRATO_ALUGUEL')
    },
    exibirOrdenacao() {
      return (this.relatorio.situacaoContrato === 'ATIVO' ||
        this.relatorio.situacaoContrato === 'ATIVO_POR_PERIODO' ||
        this.relatorio.situacaoContrato === 'NOVO' ||
        this.relatorio.situacaoContrato === 'RENOVADO_REAJUSTADO' ||
        this.relatorio.situacaoContrato === 'CONTRATOS_PRORROGADOS' ||
        this.relatorio.situacaoContrato === 'FINALIZADO' ||
        this.relatorio.situacaoContrato === 'VENCIDO') && (this.relatorio.nome === 'CONTRATO_ALUGUEL')
    },
    exibirSituacaoContrato(){
      return this.relatorio.nome === 'CONTRATO_ALUGUEL';
    },
    exibirCamposVistoria(){
      return this.relatorio.nome === 'VISTORIAS_POR_PERIODO';
    },

    // UTIL
    tiposImoveis() { return TIPOS_IMOVEIS },
    labelDatas() {
      switch (this.relatorio.situacaoContrato) {
        case 'ATIVO_POR_PERIODO':
        case 'NOVO':
        case 'RENOVADO_REAJUSTADO':
          return 'Período';
        case 'VENCIDO':
          return 'Vencidos / À vencer até';
        case 'EM_DESOCUPACAO':
          return 'Período';
        case 'FINALIZADO':
          return 'Período FIM contrato';
        case 'CONTATOS_EFETIVADOS':
          return 'Período';
        case 'CONTRATOS_PRORROGADOS':
          return 'Período';
        default:
          return '';
          
      }
    },
    tiposVistoria() { return TIPO_VISTORIA },
    statusVistoria() { return STATUS_VISTORIA },
    tipoGarantiaPesquisa(){ return TIPO_GARANTIA_PESQUISA},

    listaSituacaoContrato(){
      return [
        this.permissoes && this.permissoes.relatorioContratosAtivos && { label: 'Todos Ativos', data: 'ATIVO'},
        this.permissoes && this.permissoes.relatorioContratosAtivos && { label: 'Ativos por Período', data: 'ATIVO_POR_PERIODO'},
        this.permissoes && this.permissoes.relatorioContratosNovos && { label: 'Novos por Período', data: 'NOVO'},
        this.permissoes && this.permissoes.relatorioContratosRenovados && { label: 'Renovados/Reajustados por Período', data: 'RENOVADO_REAJUSTADO'},
        this.permissoes && this.permissoes.relatorioContratosVencidos && { label: 'Vencidos / À Vencer por Período', data: 'VENCIDO'},
        this.permissoes && this.permissoes.relatorioContratosAtivos && { label: 'Em Desocupação', data: 'EM_DESOCUPACAO'},
        this.permissoes && this.permissoes.relatorioContratosFinalizados && { label: 'Finalizados por Período', data: 'FINALIZADO'},
        this.permissoes && this.permissoes.relatorioContratosEfetivados && { label: 'Contratos Efetivados', data: 'CONTRATOS_EFETIVADOS'},
        this.permissoes && this.permissoes.relatorioContratosDeclararIr && { label: 'Contratos para Declaração de IR', data: 'DECLARAR_IR'},
        this.permissoes && this.permissoes.relatorioContratosProrrogados && { label: 'Contratos Prorrogados por Período', data: 'CONTRATOS_PRORROGADOS'},
      ].filter(Boolean);
      
    },

    exibirTipoGarantia() {
      return this.relatorio.tipoAluguel == 'GARANTIDO' && (
        this.relatorio.situacaoContrato !== 'VENCIDO' &&
        this.relatorio.situacaoContrato !== 'EM_DESOCUPACAO' &&
        this.relatorio.situacaoContrato !== 'DECLARAR_IR'
      ) && (this.relatorio.nome === 'CONTRATO_ALUGUEL')
    }
  },
  watch: {
    "relatorio.situacaoContrato": function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.relatorio.ordenacao = 'ID'
      }
    },
  },
  created() {
    if(this.permissoes && !this.permissoes.relatorioContratosAtivos) {
      this.relatorio.situacaoContrato = '';  
    }
    if(this.permissoes){ this.tiposRelatorios.push({ label: "Relatório de Contratos", value: "CONTRATO_ALUGUEL" }) }
    if(this.permissoesImoveis && this.permissoesImoveis.relatorioVistoriasPorPeriodo){ this.tiposRelatorios.push({ label: "Vistorias por Período", value: "VISTORIAS_POR_PERIODO" }) }
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions('alugueisRelatoriosStore', [
      'gerarRelatorio',
      'listarUsuarios',
    ]),
    ...mapActions('alugueisImoveisStore', [
      "recuperarCondominios"
    ]),

    montarPayload(){
      const payload = Object.assign({}, this.relatorio);

      if(payload.nome === 'CONTRATO_ALUGUEL'){
        if(payload.situacaoJuridica === 'TODOS') { delete payload.situacaoJuridica; }
        if(payload.tipoAluguel === 'TODOS') { 
          delete payload.tipoAluguel
          payload.tipoGarantia = undefined; 
        }
        if(payload.tipoAluguel === 'NAO_GARANTIDO') { payload.tipoGarantia = undefined }
        if(payload.situacaoContrato !== 'EM_DESOCUPACAO') { delete payload.parametroData; }
        //if(payload.condominio && payload.condominio.id === 0) { delete payload.condominio; }
        if(payload.situacaoContrato === 'EM_DESOCUPACAO' ||
          payload.situacaoContrato === 'DECLARAR_IR' ||
          payload.situacaoContrato === 'VENCIDO'
        ) {
          delete payload.tipoAluguel  
          delete payload.tipoGarantia
        }
        if(payload.situacaoContrato === 'EM_DESOCUPACAO') {
          payload.nome = 'ALUGUEIS_EM_DESOCUPACAO';
          delete payload.situacaoContrato;

          payload.imovel = { tipoImovel: this.relatorio.tipoImovel };
          delete payload.tipoImovel;
        }
        if(payload.situacaoContrato != 'ATIVO'){
          delete payload.valorFinal;
          delete payload.valorInicial;
          delete payload.incluirFiador;
        }
         delete payload.imovel;
      }else if(payload.nome === 'VISTORIAS_POR_PERIODO'){
        delete payload.situacaoContrato;
        delete payload.situacaoJuridica;
        delete payload.tipoAluguel;
        delete payload.tipoImovel;
        delete payload.tipoGarantia;
        delete payload.parametroData;
        delete payload.ordenacao;
        delete payload.incluirFiador;
      }
      return payload;
    },

    gerar() {
      if(this.relatorio.situacaoContrato === '') {
        this.exibirAlert('Atenção', 'Selecione a Situação do Contrato.');
        return;
      }
      let payload = this.montarPayload();
      this.showLoading();
      this.gerarRelatorio(payload)
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case 'SUCESSO':
            window.open(resultado.mensagem, "_blank");
            break;
          case 'FALHA':
            this.$message.warning('Ocorreu um erro ao gerar o relatório');
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString }
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      })
    },
    recuperarCondominiosSelect(queryString) {
      let payload = { nome: queryString };
      
      this.loadingCondominios = true;
      this.recuperarCondominios(payload)
      .then((resultado) => {
        this.condominiosDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
        this.loadingCondominios = false;
      });
    },
    limparFiltros() {
      this.relatorio = {
        nome: this.relatorio.nome,
        valorInicial: undefined,
        valorFinal: undefined,
        tipoImovel: undefined,
        situacaoContrato: 'ATIVO',
        situacaoJuridica: 'TODOS',
        imovel: { operacao: 'ALUGUEL' },
        tipoAluguel: 'TODOS',
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        parametroData: 'DATA_AVISO_DESOCUPACAO',
        ordenacao: 'ID',
        xls: false,
        incluirFiador: false
      }
    },
    reset(){
      this.relatorio = {
        nome: "",
        tipoImovel: undefined,
        situacaoContrato: 'ATIVO',
        situacaoJuridica: 'TODOS',
        tipoAluguel: 'TODOS',
        valorInicial: undefined,
        valorFinal: undefined,
        imovel: { operacao: 'ALUGUEL' },
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        parametroData: 'DATA_AVISO_DESOCUPACAO',
        ordenacao: 'ID',
        xls: false,
        incluirFiador: false
      }
      this.filtroValorAluguel = false;
    },

    fechar() {
      this.reset();
      this.$emit('close');
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },    
  }
}
</script>

<style scoped>
.form-item {
    width: 100%; 
}
.select {
  font-size: 50%;
}
.radio-align-column{
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 5px 16px;
  align-items: center;
}
</style>